var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01MasSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.54 13.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M680.52,1000.19h-2.16V998a.49.49,0,0,0-.49-.49.48.48,0,0,0-.48.49v2.16h-2.17a.49.49,0,0,0,0,1h2.17v2.16a.48.48,0,0,0,.48.49.49.49,0,0,0,.49-.49v-2.16h2.16a.49.49,0,1,0,0-1Z",
    transform: "translate(-671.1 -993.91)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M677.87,1007.45a6.77,6.77,0,1,1,6.77-6.77A6.78,6.78,0,0,1,677.87,1007.45Zm0-12.79a6,6,0,1,0,6,6A6,6,0,0,0,677.87,994.66Z",
    transform: "translate(-671.1 -993.91)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01MasSelect);
export default __webpack_public_path__ + "static/media/01_Mas_Select.3905d27c80d7a480a344e03547f3592a.svg";
export { ForwardRef as ReactComponent };